import type { QueryClient } from "@tanstack/react-query";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchAppointmentGet(
  appointmentId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching appointment");
  }

  const service = createAuthenticatedApi(PrivatesAppointmentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Appointments, appointmentId],
    queryFn: () =>
      service.getAppointmentById({
        id: appointmentId,
      }),
  });

  return queryClient;
}
